import { __extends } from "tslib";
import { BaseApiService } from "../../api/baseApiService";
import { GLOBAL_CONSTANTS } from "../../constants";
var SubjectCategoriesService = (function (_super) {
    __extends(SubjectCategoriesService, _super);
    function SubjectCategoriesService(baseUrl) {
        return _super.call(this, baseUrl) || this;
    }
    return SubjectCategoriesService;
}(BaseApiService));
export { SubjectCategoriesService };
export var subjectCategoriesService = new SubjectCategoriesService(GLOBAL_CONSTANTS.SUBJECT_CATEGORIES);
//# sourceMappingURL=subjectCategories.service.js.map